import { NoddiIcon } from 'noddi-ui-common';
import { NoddiBadge, NoddiBasicCard } from 'noddi-ui-web';
import { DepartmentOrganizationName, type UserSessionData } from 'noddi-web';
import { getUserGroupProfileTypeLabel } from '../../hooks/useUserGroupSelection';
import { getUserGroupCardDescription, isUserGroupOrganizationContext } from '../../utils/userGroupContext';

interface UserGroupSelectionProps {
  onSelect: (userGroup: { id: number; name: string }) => void;
  userGroups: UserSessionData['user']['userGroups'];
}

export const UserGroupSelection = ({ onSelect, userGroups }: UserGroupSelectionProps) => {
  return (
    <div className='flex flex-col gap-4 py-4'>
      {userGroups.map((userGroup) => {
        const isOrgContext = isUserGroupOrganizationContext(userGroup);
        const onlyDepartment = userGroup.departments.length === 1 ? userGroup.departments[0] : undefined;
        return (
          <NoddiBasicCard
            key={userGroup.id}
            size='small'
            className='group relative flex justify-between gap-4 overflow-hidden border-2 shadow-none! transition-all duration-300 hover:-translate-y-1'
            onClick={() => onSelect(userGroup)}
          >
            <div className='flex flex-row items-center gap-3'>
              <NoddiIcon name={isOrgContext ? 'Building2' : 'CircleUserRound'} size='medium' />
              <div className='flex flex-col gap-1'>
                <div className='flex items-center gap-2'>
                  {onlyDepartment ? (
                    <DepartmentOrganizationName
                      departmentName={onlyDepartment.name}
                      organizationName={onlyDepartment.organizationName}
                      className='text-sm leading-tight'
                    />
                  ) : (
                    <h3 className='text-sm leading-tight font-semibold'>{userGroup.name}</h3>
                  )}
                  <NoddiBadge variant={isOrgContext ? 'info' : 'outline'}>
                    {getUserGroupProfileTypeLabel(userGroup)}
                  </NoddiBadge>
                </div>
                <p className='text-xs text-muted-foreground'>{getUserGroupCardDescription(userGroup)}</p>
              </div>
            </div>

            <div className='flex justify-center'>
              <div className='text-muted-foreground transition-all duration-300 group-hover:translate-x-1 group-hover:text-primary'>
                <NoddiIcon name='ArrowRight' size='small' />
              </div>
            </div>

            <div className='absolute inset-0 bg-primary/5 opacity-0 transition-opacity duration-300 group-hover:opacity-100' />
          </NoddiBasicCard>
        );
      })}
    </div>
  );
};
